import { useState, useEffect } from "react";
import { useFormik } from "formik";
import createRegisterForm from "@serie3/common/Form/Register/RegisterForm";
import { Form, Modal } from "react-bootstrap";

const RegisterModal = ({ show, setShow, setShowLogin, showLoginForm = true }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showProcess, setShowProcess] = useState(false);

  const registerForm = createRegisterForm(setShowSuccess, setShowError, setShowProcess);
  const formik = useFormik(registerForm);

  useEffect(() => {
    setShowSuccess(false);
    setShowError(false);
  }, [show]);

  const showLogin = () => { setShow(false); setShowLogin(true); };

  return (
    <Modal
      size="md"
      show={show}
      onHide={() => setShow(false)}
      centered
      animation={false}
      dialogClassName="lp-modal"
    >
      <Modal.Header closeButton className="lp-modal-header" />
      <Modal.Body className="lp-modal-body">
        <h2 className="lp-modal-title">Create your account</h2>
        <p className="lp-modal-subtitle">Start your 30-day free trial — no credit card required</p>

        {!showSuccess ? (
          <Form onSubmit={formik.handleSubmit}>
            <Form.Group className="lp-form-group" controlId="username">
              <Form.Label className="lp-form-label">Full name</Form.Label>
              <Form.Control
                type="text"
                name="username"
                placeholder="Jane Doe"
                onChange={formik.handleChange}
                value={formik.values.username}
                isInvalid={!!formik.errors.username}
                className="lp-form-input"
              />
              <Form.Control.Feedback type="invalid">{formik.errors.username}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="lp-form-group" controlId="email">
              <Form.Label className="lp-form-label">Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="you@example.com"
                onChange={formik.handleChange}
                value={formik.values.email}
                isInvalid={!!formik.errors.email}
                className="lp-form-input"
              />
              <Form.Control.Feedback type="invalid">{formik.errors.email}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="lp-form-group" controlId="password">
              <Form.Label className="lp-form-label">Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="Min. 8 characters"
                onChange={formik.handleChange}
                value={formik.values.password}
                isInvalid={!!formik.errors.password}
                className="lp-form-input"
              />
              <Form.Control.Feedback type="invalid">{formik.errors.password}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="lp-form-group" controlId="passwordconfirmation">
              <Form.Label className="lp-form-label">Confirm password</Form.Label>
              <Form.Control
                type="password"
                name="passwordconfirmation"
                placeholder="••••••••"
                onChange={formik.handleChange}
                value={formik.values.passwordconfirmation}
                isInvalid={!!formik.errors.passwordconfirmation}
                className="lp-form-input"
              />
              <Form.Control.Feedback type="invalid">{formik.errors.passwordconfirmation}</Form.Control.Feedback>
            </Form.Group>

            {showProcess && (
              <div className="lp-alert lp-alert-info">Processing your sign up…</div>
            )}
            {showError && (
              <div className="lp-alert lp-alert-error">
                Something went wrong. Try a different email or make sure your password is at least 8 characters.
              </div>
            )}

            <button type="submit" className="lp-form-submit">
              Create account
            </button>
          </Form>
        ) : (
          <div className="lp-alert lp-alert-success" style={{ marginTop: "1rem" }}>
            <strong>Account created!</strong>
            <br />
            Check your inbox (and spam folder) for a verification email.
          </div>
        )}

        <p className="lp-modal-footer-text">
          Already have an account?{" "}
          {showLoginForm ? (
            <span className="lp-form-link" onClick={showLogin}>Sign in</span>
          ) : (
            <a href="/" className="lp-form-link">Sign in</a>
          )}
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default RegisterModal;
